module.exports = __webpack_public_path__ + "a5a19cb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/src/src_img/dl_playstore@2x.png
// module id = 1032
// module chunks = 0